import { isChunkLoadError } from './isChunkLoadError';
import { reportChunkLoadFailure } from './reportChunkLoadFailure';

/** Shape of the event Vite dispatches on `window` when a preload fails. */
interface VitePreloadErrorEvent extends Event {
  payload: unknown;
}

/**
 * Measures chunk failures that never reach the router error page, such as a
 * lazy component inside a page or a CSS dependency that fails to preload.
 *
 * Observes only: it does not call `preventDefault()`, so Vite still rethrows
 * the error and existing error boundaries and the route error page behave as
 * before.
 *
 * @returns a function that removes the listener.
 */
export const registerPreloadErrorListener = (): (() => void) => {
  const handler = (event: Event): void => {
    const { payload } = event as VitePreloadErrorEvent;
    if (isChunkLoadError(payload)) {
      reportChunkLoadFailure(payload).catch(() => {});
    }
  };

  window.addEventListener('vite:preloadError', handler);
  return () => window.removeEventListener('vite:preloadError', handler);
};
